import React, { useMemo } from "react";

import { useHttpMetricsContext } from "src/organization/pages/project/environment/metrics/http/context";
import { HttpMetricsType } from "src/organization/pages/project/environment/metrics/http/types";

import * as S from "../style";
import ImpactTable from "../table";
import { getTimeRangeImpactSeries, getTopRangeImpact } from "../util";

import TimeRangeImpactChart from "./TimeRangeChart";

const impactCount = 10;

const TopUrlView = ({ data }: { data: HttpMetricsType[] }) => {
  const topRangeImpact = getTopRangeImpact(
    data,
    useHttpMetricsContext()?.data,
    impactCount
  );

  const timerangeImpactSeries = useMemo(
    () => getTimeRangeImpactSeries(data, topRangeImpact),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [topRangeImpact]
  );

  return (
    <S.ImpactContainer>
      <S.ImpactWraper id="http-url-impact">
        <TimeRangeImpactChart
          impactCount={impactCount}
          topImpact={timerangeImpactSeries}
        />
      </S.ImpactWraper>
      <hr />
      <S.TopListWraper>
        <ImpactTable highImpact={topRangeImpact} />
      </S.TopListWraper>
    </S.ImpactContainer>
  );
};

export default TopUrlView;
